import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadDealerWiseExcel, downloadPendingOrdersProducts, getDealerWisePendingOrdersdProducts, getPendingOrdersProducts } from '@/api/orders-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import { searchDealers } from '@/api/dealers';
import { searchProducts } from '@/api/products';
import { getRanges } from '@/api/ranges';
import { AdminModule } from '@/store/modules/admin';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isSuperAdmin } from '@/common';
import { getCategories } from '@/api/categories';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.isAgent = false;
    this.listLoading = true;
    this.downloadLoading = false;
    this.dealerList = [];
    this.dealerListLoading = false;
    this.productList = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.agentList = [];
    this.productListLoading = false;
    this.rangeList = [];
    this.dateRange = null;
    this.grandTotalCartons = null;
    this.grandTotal = null;
    this.grandTotalPending = null; // dealer-wise pending qty total
    this.grandTotalAmount = null; // dealer-wise pending amount total
    this.assignedBranches = [] || null;
    this.showFilters = false;
    this.isDealerWise = false;
    this.categoryId = null;
    this.subCategoryId = null;
    this.categoryList = [];
    this.subCategoryList = [];
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      productId: undefined,
      rangeId: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined,
      agentId: undefined,
      sort: undefined,
      categoryId: undefined,
      subCategoryId: undefined
    };
  }
  async activated() {
    try {
      if (AdminModule.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = AdminModule.agentId;
      }
      this.assignedBranches = await BranchAgentService.assignBranchId();
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.getList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      this.listLoading = true;
      this.listQuery.categoryId = undefined;
      if (this.categoryId) {
        this.listQuery.categoryId = this.categoryId;
      }
      if (this.subCategoryId) {
        this.listQuery.subCategoryId = this.subCategoryId;
      }
      let data;
      if (!this.isDealerWise) {
        data = await getPendingOrdersProducts(this.listQuery);
      } else {
        data = await getDealerWisePendingOrdersdProducts(this.listQuery);
      }
      this.rangeList = await getRanges(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
      // Add computed cartons field to every row
      this.list = data.data.map(item => {
        const pendingQty = this.isDealerWise ? Number(item.pendingQuantity) : Number(item.total);
        return {
          ...item,
          cartons: (pendingQty / Number(item.masterCarton || 1)).toFixed(2)
        };
      });
      this.total = data.total;
      if (!this.isDealerWise) {
        // product-wise grand totals
        this.grandTotalCartons = data.grandTotal.grandTotalCartons;
        this.grandTotal = data.grandTotal.grandTotal;
      } else {
        // dealer-wise grand totals
        this.grandTotalPending = data.grandTotal.grandTotalPending;
        this.grandTotalCartons = data.grandTotal.grandTotalCartons;
        this.grandTotalAmount = data.grandTotal.grandTotalAmount;
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  // ── Summary row for product-wise table ──────────────────────────────────
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    const sumsCarton = [];
    columns.forEach((column, index) => {
      if (index === 3) {
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(v => isNaN(v))) {
          sums[index] = values.reduce((prev, curr) => !isNaN(Number(curr)) ? prev + Number(curr) : prev, 0);
        }
      }
      if (index === 4) {
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(v => isNaN(v))) {
          sumsCarton[index] = values.reduce((prev, curr) => !isNaN(Number(curr)) ? prev + Number(curr) : prev, 0);
        }
      }
    });
    if (sums && sums.length) {
      var _this$grandTotalCarto, _this$grandTotal;
      sumsCarton[4] = `${Number(sumsCarton[4]).toFixed(2)}/${(_this$grandTotalCarto = this.grandTotalCartons) === null || _this$grandTotalCarto === void 0 ? void 0 : _this$grandTotalCarto.toFixed(2)}`;
      sums[3] = `${Number(sums[3]).toFixed(2)}/${(_this$grandTotal = this.grandTotal) === null || _this$grandTotal === void 0 ? void 0 : _this$grandTotal.toFixed(2)}`;
    }
    return [,,, sums, sumsCarton];
  }
  // ── Summary row for dealer-wise table ───────────────────────────────────
  getDealerWiseSummaries(param) {
    var _this$grandTotalPendi, _this$grandTotalCarto2, _this$grandTotalCarto3, _this$grandTotalAmoun;
    const {
      columns,
      data
    } = param;
    const result = columns.map(() => '');
    // Column order: BranchCode, BranchId, DealerId, DealerName, Product,
    //               Color, OrderedQty, DispatchedQty, PendingQty, Cartons, PendingAmount
    //               idx:  0           1         2         3          4
    //                     5           6          7             8         9       10
    result[0] = 'Page Total';
    // Pending Qty (index 8)
    const pendingQtys = data.map(item => Number(item.pendingQuantity));
    result[8] = `${pendingQtys.reduce((a, b) => a + b, 0)} / ${(_this$grandTotalPendi = this.grandTotalPending) !== null && _this$grandTotalPendi !== void 0 ? _this$grandTotalPendi : ''}`;
    // Cartons (index 9)
    const cartons = data.map(item => Number(item.cartons));
    result[9] = `${cartons.reduce((a, b) => a + b, 0).toFixed(2)} / ${(_this$grandTotalCarto2 = (_this$grandTotalCarto3 = this.grandTotalCartons) === null || _this$grandTotalCarto3 === void 0 ? void 0 : _this$grandTotalCarto3.toFixed(2)) !== null && _this$grandTotalCarto2 !== void 0 ? _this$grandTotalCarto2 : ''}`;
    // Pending Amount (index 10)
    const amounts = data.map(item => Number(item.pendingAmount));
    const pageAmount = amounts.reduce((a, b) => a + b, 0);
    result[10] = `₹${pageAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2
    })} / ₹${Number((_this$grandTotalAmoun = this.grandTotalAmount) !== null && _this$grandTotalAmoun !== void 0 ? _this$grandTotalAmoun : 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2
    })}`;
    return result;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        applyBranchIdFilter: true,
        fromDealer: true,
        searchBy: isNumeric ? 'dealerId' : 'name'
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line no-empty
  }
  async fetchProductList(query) {
    try {
      if (query.length > 2) {
        this.productListLoading = true;
        this.productList = await searchProducts({
          keyword: query
        });
      }
      this.productListLoading = false;
    } catch (err) {} // eslint-disable-line no-empty
  }
  async handleClearBranch() {
    this.listQuery.branchId = await BranchAgentService.assignBranchId();
    this.branchList = await BranchAgentService.fetchBranches(this.listQuery.branchId);
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = null;
      this.listQuery.endDate = null;
    }
    this.listQuery.page = 1;
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
    }
    this.getList();
  }
  handleSubCategoryFilter() {
    this.subCategoryId = undefined;
    if (this.categoryId) {
      this.fetchSubCategories();
    } else {
      this.categoryId = undefined;
    }
    this.getList();
  }
  async fetchSubCategories() {
    if (this.categoryId) {
      this.subCategoryList = await getCategories(getQuery({
        enabled: true,
        parentId: this.categoryId,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$eq',
          rangeId: '$eq'
        }
      }));
      if (this.subCategoryList.length === 0) {
        this.subCategoryId = undefined;
      }
    } else {
      this.subCategoryList = [];
    }
  }
  handleCategoryFilter() {
    this.categoryId = undefined;
    this.subCategoryId = undefined;
    this.fetchCategories();
    this.getList();
  }
  async fetchCategories() {
    if (this.listQuery.rangeId) {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$isnull',
          rangeId: '$in'
        }
      }));
      if (this.categoryList.length === 0) {
        this.categoryId = undefined;
      }
    } else {
      this.categoryList = [];
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  async downloadData() {
    this.listLoading = true;
    try {
      const params = {
        applyBranchIdFilter: true
      };
      if (this.listQuery.dealerId) params.dealerId = this.listQuery.dealerId;
      if (this.listQuery.productId) params.productId = this.listQuery.productId;
      if (this.listQuery.rangeId) params.rangeId = this.listQuery.rangeId;
      if (this.listQuery.branchId) params.branchId = this.listQuery.branchId;
      if (this.dateRange) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      if (this.listQuery.agentId) params.agentId = this.listQuery.agentId;
      const data = await downloadPendingOrdersProducts(this.listQuery);
      window.open(data.url, '_blank');
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async handleExcelDownload() {
    try {
      const blob = await downloadDealerWiseExcel(this.listQuery);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'dealer-wise-pending-orders-products.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.$message.error('Error downloading Excel');
    }
  }
};
default_1 = __decorate([Component({
  name: 'PendingOrdersProductList',
  components: {
    Pagination
  }
})], default_1);
export default default_1;